<template>
	<canvas id="canvas"></canvas>
	<canvas id="layer"></canvas>
	<div class="flex w-full flex-col items-center justify-center">
		<img src="/img/logo.png" class="mb-8 w-[240px]" />
		<div class="cardBox">
			<div class="cardBox_first"></div>
			<div class="card">
				<div v-show="!tokenFraud">
					<p class="text-[28px] sm:text-[20px]">パスワードの設定</p>

					<p class="mt-8 font-normal sm:text-[14px]">
						パスワードの再設定を行ってください。
					</p>

					<div class="mt-12 w-full">
						<InputForm
							v-model="formData.email"
							:type="'text'"
							:title="'メールアドレス'"
							:text="''"
							:required="false"
							:disabled="false"
							:form-class="'w-full'"
							:maxlength="255"
							:placeholder="'test@gmail.com'"
							:error-text="errors.email"
						/>
					</div>

					<div class="mt-8 w-full">
						<PasswordForm
							v-model="formData.password"
							:title="'パスワード'"
							:required="false"
							:disabled="false"
							:form-class="'w-full'"
							:maxlength="20"
							:placeholder="''"
							:error-text="errors.password"
						/>
					</div>

					<div class="mt-12 flex justify-center">
						<Button
							:button-type="'submit'"
							:button-class="''"
							:button-icon="'fa-save'"
							:button-text="'設定する'"
							@click="passwordSetting"
						/>
					</div>
				</div>

				<div v-show="tokenFraud">
					<p class="text-[28px] sm:text-[20px]">トークンが失効しています</p>

					<p class="mt-8 font-normal sm:text-[14px]">
						パスワード再設定の有効化リンクをクリックした場合、<b
							class="text-color-red2"
							>有効化リンクが失効</b
						>している場合、または<b style="font-size: 1.6rem; color: #f13757"
							>URLが不正</b
						>な場合のいずれかに発生します。
					</p>
					<p class="mt-2 font-normal sm:text-[14px]">
						有効期限切れ等でトークンが失効となってしまった場合は、お手数おかけいたしますが再度パスワードリセットを行ってください。
					</p>

					<div class="mt-12 flex justify-center">
						<Button
							:button-type="'submit'"
							:button-class="'button-gray'"
							:button-icon="'fa-chevron-left'"
							:button-text="'ログイン画面に戻る'"
							@click="routeBack"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import InputForm from "@/components/molecules/form/InputForm.vue";
import PasswordForm from "@/components/molecules/form/PasswordForm.vue";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
// stubs
import * as passwordStub from "@/stubs/Password.js";
//store
import { usePartsStore } from "@/stores/PartsStore";
// utils
import bgAnimaion from "@/utils/BgAnimaion.js";
import toaster from "@/utils/Toaster.js";
// api
import FunctionApi from "@/api/FunctionApi.js";

const partsStore = usePartsStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
	router
---------------------------------------------------------------------------- */
const router = useRouter();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { alert } = toaster();
const { animation } = bgAnimaion();
/* ---------------------------------------------------------------------------
	data
---------------------------------------------------------------------------- */
const formData = ref({ ...passwordStub.resetData });
const tokenFraud = ref(false);
const errors = ref([]);

/* ---------------------------------------------------------------------------
	tokenの取得
---------------------------------------------------------------------------- */
async function getToken() {
	await functionApi.password.getToken(formData.value.token).then(res => {
		if (res.result) {
			tokenFraud.value = false;
			formData.value.email = res.data.email;
		} else {
			tokenFraud.value = true;
			errors.value = res.errors;
			alert("warning");
		}
	});
}
/* ---------------------------------------------------------------------------
	パスワード再設定
---------------------------------------------------------------------------- */
async function passwordSetting() {
	partsStore.detailLoader = true;
	await functionApi.password.reset(formData.value).then(res => {
		partsStore.detailLoader = false;
		// 成功
		if (res.result) {
			// ログイン画面に遷移
			routeBack();
			alert("update");
			// 失敗
		} else {
			errors.value = res.errors;
			alert("error_reset");
		}
	});
}
/* ---------------------------------------------------------------------------
	戻る
---------------------------------------------------------------------------- */
function routeBack() {
	history.back();
}

onMounted(() => {
	animation();

	// pathからtokenを取得
	const token = route.params.token;
	formData.value.token = token;

	// tokenの取得
	// getToken();
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.cardBox {
	position: relative;
	width: 100%;
	max-width: 640px;
}
.cardBox_first {
	background: $bg-white1;
	height: 10px;
	border-radius: 5px 5px 0 0;
	margin: 0 10px;
	padding: 0;
}

.card {
	position: relative;
	background: $bg-white2;
	border-radius: 5px;
	padding: 60px 40px 40px;
	box-sizing: border-box;
	@include boxShadow(0.15);
	@include trans(0.3);
}

.card_alt {
	position: absolute;
	top: 40px;
	right: -20px;
	z-index: 10;
	width: 60px;
	height: 60px;
	background: none;
	border-radius: 100%;
	box-shadow: none;
	padding: 0;
	@include trans(0.3);
}
.card_alt_toggle {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	background: #e7fefd;
	width: 60px;
	height: 60px;
	border: 3px solid $primaryColor;
	border-radius: 100%;
	color: $primaryColor;
	text-align: center;
	cursor: pointer;
}
.card_alt_content,
.card_alt_title {
	left: 100px;
	opacity: 0;
	display: none;
	visibility: hidden;
}
.card_alt_title i {
	@include trans(0.3);
	&:hover {
		color: $color-blue2;
		@include trans(0.3);
	}
}
@media screen and (max-width: 480px) {
	.card {
		padding: 40px 20px;
	}

	.cardBox {
		width: 84%;
		min-width: auto;
		max-width: auto;
	}
}
#layer {
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100%;
	z-index: -1;
	background: $bg-white2;
	@include backdropFilter(5px);
	@include glassmorphism(0.5);
}
#canvas {
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100%;
	z-index: -2;
}
</style>
